import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material';
import * as toastr from 'toastr'

@Component({
  selector: 'app-material-table-container',
  templateUrl: './material-table-container.component.html',
  styleUrls: ['./material-table-container.component.scss']
})
export class MaterialTableContainerComponent implements OnInit {
  @Input() loading = false;
  @Input() pageIndex = 1;
  @Input() length = 0;
  @Input() showEmptyTableText = false;
  @Input() paginationDisabled = false;
  @Input() paginationDisabledClickMessage = 'Paginação desabilitada';
  @Output('page') pageEventEmitter = new EventEmitter<PageEvent>()

  constructor() { }

  ngOnInit() {
  }

  handlePageOrSizeChange(pageEvent: PageEvent){
    this.pageEventEmitter.emit(pageEvent);
  }

  handlePaginationClick(){
    if(this.paginationDisabled){
      toastr.error(this.paginationDisabledClickMessage)
    }
  }

}
